import { useTranslation } from 'react-i18next';
import PicturizedImage from '@/components/common/picturized-image';
import { transformLocaleCode } from '@/utils/language-code';

export default function PwaGuideImage() {
  const { i18n } = useTranslation();

  const resolvedLocale = transformLocaleCode(i18n.resolvedLanguage).toLowerCase();

  const url = `pwa-guide.${resolvedLocale}`;
  const picture = {
    img: { src: `/${url}.png` },
    sources: {
      avif: `/${url}.avif`,
      webp: `/${url}.webp`,
    },
  };

  return <PicturizedImage picture={picture} />;
}
